if (!customElements.get('collection-tabs')) {
  customElements.define(
    'collection-tabs',
    class CollectionTabs extends HTMLElement {
      constructor() {
        super();

        this.tab = this.querySelector('tabs-component');
        this.tabPanels = this.querySelectorAll('[role="tabpanel"]');
        this.tabNavs = this.querySelectorAll('[role="tab"]');
        this.contentWrapper = this.querySelector('.collection-tabs__content');
        this.imagesWrapper = this.querySelector('.collection-tabs__images');
        this.sectionWrapper = this.closest('.section--collection-tabs');
        this.seoWrapper = this.sectionWrapper?.querySelector('.collection-tabs__seo-wrapper');
        this.seoPanels = this.sectionWrapper?.querySelectorAll('.collection-tabs__seo-panel') || [];
        this.seoToggleButtons = this.sectionWrapper?.querySelectorAll('[data-seo-toggle]') || [];
        this.tooltipEl = this.querySelector('.tooltip-element');
        this.alignItems = window.getComputedStyle(this).getPropertyValue('align-items');

        this.init();
      }

      connectedCallback() {
        this.tab.addEventListener('tabChange', (event) => {
          this.handleTabChange(event);
        });
      }

      init() {
        this.handleTooltip(0);
        this.handleSeoPanelChange(0);
        this.handleSeoToggle();
        this.calculatePadding();
        window.addEventListener('resize', this.calculatePadding.bind(this));
      }

      handleTabChange(event) {
        const {selectedIndex} = event.detail;
        this.handleTooltip(selectedIndex);
        this.handleSeoPanelChange(selectedIndex);

        this.imagesWrapper.querySelectorAll('.collection-tabs__image').forEach((image) => image.classList.remove('is-active'));
        this.imagesWrapper.querySelector(`.collection-tabs__image[data-index="${selectedIndex}"]`).classList.add('is-active');
      }

      handleTooltip(tabIndex) {
        if (!window.matchMedia("(hover: hover)").matches) return;
        const currentTab = this.tabPanels[tabIndex];
        const productListWrapper = currentTab.querySelector('.collection-tab__products');
        const hoverEls = productListWrapper.querySelectorAll('a');

        hoverEls.forEach((el) => {
          el.addEventListener('mousemove', (e) => {
            const { target } = e;
            const title = target.dataset.title;

            this.tooltipEl.innerHTML = title;

            this.tooltipEl.style.opacity = '1';
            this.tooltipEl.style.top = `${e.clientY - this.tooltipEl.offsetHeight - 5}px`;
            this.tooltipEl.style.left = `${e.clientX}px`;
          });

          el.addEventListener('mouseleave', (e) => {
            this.tooltipEl.style.opacity = '0';
          })
        });
      }

      handleSeoPanelChange(selectedIndex) {
        if (!this.seoWrapper || !this.seoPanels.length) return;

        let hasContent = false;

        this.seoPanels.forEach((panel) => {
          const isActive = Number(panel.dataset.index) === selectedIndex;
          panel.hidden = !isActive;

          if (isActive && panel.dataset.empty !== 'true') {
            hasContent = true;
          }
        });

        this.seoWrapper.hidden = !hasContent;
      }

      handleSeoToggle() {
        if (!this.seoToggleButtons.length) return;

        this.seoToggleButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const panel = button.closest('.collection-tabs__seo-panel');
            const preview = panel?.querySelector('[data-seo-preview]');
            const fullContent = panel?.querySelector('[data-seo-full]');
            const buttonText = button.querySelector('.button-text');
            const isExpanded = button.getAttribute('aria-expanded') === 'true';

            if (!preview || !fullContent || !buttonText) return;

            preview.hidden = !isExpanded;
            fullContent.hidden = isExpanded;
            button.setAttribute('aria-expanded', String(!isExpanded));
            buttonText.textContent = isExpanded ? button.dataset.showText : button.dataset.hideText;
          });
        });
      }

      calculatePadding() {
        if (!this.contentWrapper) return;
        this.contentWrapper.style.marginTop = '0';
      }
    }
  );
}
